/**
 * undercover® — sticky scroll-storytelling.
 * Het tekstblok dat een vaste lijn op het scherm passeert, wordt actief; het bijbehorende beeld
 * crossfadet in. Desktop: lijn in het midden. Mobiel: lijn net onder het compacte sticky beeld.
 * Werkt met Horizons .page-wrapper-scroller (desktop) én met window-scroll (mobiel): scroll-events
 * worden in de capture-fase opgevangen en per frame verwerkt, alleen als de sectie in beeld is.
 */
if (!customElements.get('uc-sticky-story')) {
  class UcStickyStory extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.images = [...this.querySelectorAll('[data-step-image]')];
      this.dots = [...this.querySelectorAll('[data-step-dot]')];
      this.counter = this.querySelector('[data-step-current]');
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.frame = 0;

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };

      // Alleen luisteren zolang de sectie (bijna) in beeld is
      this.inView = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
            window.addEventListener('resize', this.onScroll, { passive: true });
            this.update();
          } else {
            document.removeEventListener('scroll', this.onScroll, { capture: true });
            window.removeEventListener('resize', this.onScroll);
          }
        },
        { rootMargin: '25% 0px 25% 0px' }
      );
      this.inView.observe(this);

      this.onSelect = (event) => {
        const index = this.steps.findIndex((step) => step === event.target || step.contains(event.target));
        if (index > -1) this.activate(index);
      };
      document.addEventListener('shopify:block:select', this.onSelect);
      this.update();
    }

    disconnectedCallback() {
      this.inView?.disconnect();
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('shopify:block:select', this.onSelect);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    update() {
      // desktop: midden van het scherm; mobiel: net onder het sticky beeld
      const visual = this.querySelector('.uc-story-sticky__visual');
      const line = this.desktop.matches || !visual
        ? window.innerHeight * 0.5
        : Math.min(visual.getBoundingClientRect().bottom + 48, window.innerHeight * 0.8);
      if (visual && !this.desktop.matches) {
        const stuckAt = parseFloat(getComputedStyle(visual).top) || 0;
        visual.classList.toggle('is-stuck', visual.getBoundingClientRect().top <= stuckAt + 1);
      }
      let index = 0;
      this.steps.forEach((step, i) => {
        if (step.getBoundingClientRect().top <= line) index = i;
      });
      this.activate(index);
    }

    activate(index) {
      if (index === this.current) return;
      this.current = index;
      const toggle = (list) => list.forEach((el, i) => el.classList.toggle('is-active', i === index));
      toggle(this.steps);
      toggle(this.images);
      toggle(this.dots);
      if (this.counter) this.counter.textContent = String(index + 1).padStart(2, '0');
      this.dispatchEvent(new CustomEvent('uc:story-step', { bubbles: true, detail: { index } }));
    }
  }

  customElements.define('uc-sticky-story', UcStickyStory);
}
